const removeLettersAfterWord = (str, wordToFind) => {
  const index = str.indexOf(wordToFind);
  if (index !== -1) {
    return str.substring(0, index + wordToFind.length);
  }
  return undefined;
};

export default removeLettersAfterWord;
